// extracted by mini-css-extract-plugin
export default {"writePostBtnWrapper":"px9hcfRdEL5TpF4CznQP","writePostBtn":"Day4Ygx6n7gTSWW0A4he"};